import { render } from "./ViewBusinessAccount.vue?vue&type=template&id=55b14c9a"
import script from "./ViewBusinessAccount.vue?vue&type=script&lang=js"
export * from "./ViewBusinessAccount.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__